<template>
    <div class="ui-content dashboard">
        <div class="page-user user">
        <v-card class="mx-auto normal-card">
            <div class="data-table-section" ref="infoBox">
                <v-data-table
                    :headers="headers"
                    fixed-header
                    :items="items"
                    hide-default-footer
                    hide-default-header
                    class="elevation-2 cust-table"
                >
                    <template v-slot:header="{ props: { headers } }">
                        <TableHeader
                            :headers="headers"
                            :onHeaderAction="onHeaderAction"
                            :orderBy="orderBy"
                            :onSortChange="onSortChange"
                        />
                    </template>
                    <template v-slot:body="{ items }">
                        <tbody>
                            <tr v-for="item in items" :key="item.id">
                                <td
                                    :class="[
                                        category == 'ONGOING'
                                            ? ' rescheduletest '
                                            : '',
                                    ]"
                                    class="text-left"
                                    @click="gotoTest(item)"
                                >
                                    {{ item.alt_test_name }}
                                </td>
                                <td class="text-center">{{ item.duration }}</td>
                                <td class="text-left">
                                    <div class="date-ui">
                                        {{
                                            getFormatedDate(
                                                item.scheduled_start
                                            )
                                        }}
                                    </div>
                                    <div class="time-ui">
                                        {{
                                            getFormatedTime(
                                                item.scheduled_start
                                            )
                                        }}
                                    </div>
                                </td>
                                 <td class="text-left">
                   <template v-if="item.is_shared_test">
                    <v-tooltip 
                      left
                      bottom
                      content-class="cust-new-tooltip-bottom open-bottom tooltip-arrow-top"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <div class="date-ui" v-bind="attrs" v-on="on">
                          {{ getFormatedDate(item.scheduled_end) }}
                        </div>
                        <div class="time-ui">
                          {{ getFormatedTime(item.scheduled_end) }}
                        </div>
                      </template>
                    <span class="text-center tool-tip-position">
  <b>OMR Upload Deadline:</b><br>
  <b>{{ item && item.omr_upload_time ? getFormatedDate(item.omr_upload_time) : '' }}</b>
  {{ item && item.omr_upload_time ? getFormatedTime(item.omr_upload_time) : '' }}
</span>

                    </v-tooltip>
                  </template>
                    <template v-else>
                    <div class="date-ui">
                      {{ getFormatedDate(item.scheduled_end) }}
                    </div>
                    <div class="time-ui">
                      {{ getFormatedTime(item.scheduled_end) }}
                    </div>
                  </template>
                  <!-- <div class="date-ui">
                    {{ getFormatedDate(item.scheduled_end) }}
                  </div>
                  <div class="time-ui">
                    {{ getFormatedTime(item.scheduled_end) }}
                  </div> -->
                </td>
                                <!-- <td class="text-left">
                                    <div class="date-ui">
                                        {{
                                            getFormatedDate(item.scheduled_end)
                                        }}
                                    </div>
                                    <div class="time-ui">
                                        {{
                                            getFormatedTime(item.scheduled_end)
                                        }}
                                    </div>
                                </td> -->
                                <td class="text-left">
                                    {{ item.target_name }}
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-data-table>
                <div
                    class="btm-test-prev-test text-right"
                    v-if="category == 'ONGOING'"
                >
                    Click on a test name to start answering that test
                </div>
            </div>
        </v-card>
        <div class="footer-btn">
            <div class="pull-left"></div>
            <div class="pull-right">
                <Pagination
                    :currentPage="currentPage"
                    :totalPage="totalPages"
                    :onPageChange="onPageChange"
                />
            </div>
        </div>
        <AlertBox
            :width="modalwidth"
            :onClose="onClose"
            :component="cComponent"
            :status="status"
            :data="alertBoxData"
        />
    </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";
import { detect } from "detect-browser";
export default {
    name: "UpcomingTests",
    props: ["","tab","value"],
    data() {
        return {
            alertBoxData: null,
            status: false,
            cComponent: "",
            modalwidth: null,
            orderBy: {
                field: "test_name",
                order: "ASC",
            },
            currentPage: 1,
            pageSize: 10,
            category:'',
            totalPages: 1,
            headers: [
                {
                    text: "Test Name",
                    class: "text-left",
                    value: "alt_test_name",
                    hideSort: true,
                },
                {
                    text: "Duration(mins)",
                    class: "text-center",
                    value: "duration",
                    hideSort: true,
                },
                {
                    text: "Start Date & Time",
                    class: "text-center",
                    value: "scheduled_start",
                    hideSort: false,
                },
                {
                    text: "End Date & Time",
                    class: "text-center",
                    value: "scheduled_end",
                    hideSort: false,
                },
                {
                    text: "Target Exam",
                    class: "text-left",
                    value: "target_exam",
                    hideSort: true,
                },
            ],
            items: [],
            browserInfo: null,
        };
    },
    mounted() {
        this.category = this.$route.name === 'live-test' ? 'ONGOING' : 'UPCOMING'
        // this.requestGetTestList();
        this.checkSessionData();
        this.browserInfo = detect();
    },
    methods: {
        ...mapActions({
            getScheduleTestList: "testStore/getScheduleTestList",
        }),       
        defaultData() {
            let routeName = this.$route.name;
            let crd = this.getCurrentRouteDetails(routeName);
            if(crd) {
                this.currentPage = crd.tabDetails.default.page;
                this.orderBy = crd.tabDetails.default.orderBy;
            }
            this.requestGetTestList();
        },
        checkBrowserSupport() {
            if (!this.browserInfo || !this.browserInfo.name) return false;
            let browserName = this.browserInfo.name;
            let nAgent = navigator.userAgent.toLowerCase();
            let isSupported = true;
            this.UNSUPPROTED_BROWSERS.forEach((browser) => {
                if (nAgent.includes(browser)) {
                    isSupported = false;
                }
            });

            if (
                isSupported &&
                (browserName == "firefox" ||
                    browserName == "chrome" ||
                    browserName == "safari" ||
                    browserName == "crios" ||
                    browserName == "fxios" ||
                    browserName == "ios")
            ) {
                return true;
            }
            return false;
        },
        checkSessionData() {
            let rp = this.$route; // route params
            let crd = this.getCurrentRouteDetails(rp.name);
            
            if(rp.params.resetPage || !crd.routeName) {
                let orderField = this.roleIds.ST === this.user.role_id ? 'test_name' : 'alt_test_name';
                let tabDetail = {
                    default:{

                        page: 1,
                        orderBy: {
                            field: orderField,
                            order: "ASC"
                        }
                    }
                        
                };
                let routeDetails = {
                    routeName: rp.name,
                    selectedTab: this.tab,
                    tabDetails: tabDetail
                }
                this.setRouteDetails(routeDetails);
            }
            this.defaultData()
        },
        onClose(data) {
            this.status = data.status;
        },
        showBrowserMessage() {
            this.cComponent = "components/common/BrowserSupport";
            this.modalwidth = "700px";
            this.status = true;
            this.alertBoxData = { persistent: false };
            this.$forceUpdate();
        },
        gotoTest(test) {
            if (this.category == "ONGOING" && this.user.role_id === this.roleIds.ST) {
                if (this.checkBrowserSupport()) {
                    sessionStorage.removeItem('changedTab')
                    localStorage.setItem("previousPath", this.$route.path);
                    this.$router.push({
                        name: "instructions-about-test",
                        params: {
                            test_id: test.test_id,
                            test_institute_id: test.test_institute_id,
                            test_schedule_id: test.schedule_id
                        },
                    });
                } else {
                    this.showBrowserMessage();
                }
            }
        },
        onHeaderAction(e) {
            if (e.header && e.header.type === "check") {
            }
        },
        getFormatedDate(date) {
            return moment(date).format("DD/MM/YYYY");
        },
        getFormatedTime(date) {
            return moment(date).format("hh:mm A");
        },
        onSortChange() {
            this.requestGetTestList();
        },
        onPageChange(e) {
            this.currentPage = e;
            this.requestGetTestList();
        },
        requestGetTestList() {
            let reqData = {
                category: this.category,
                orderBy: this.orderBy,
                pagination: { page: this.currentPage, pageSize: this.pageSize },
            };
            this.$root.showLoader = true;
            this.getScheduleTestList(reqData)
                .then((response) => {
                    if(response.list.length == 0 && this.currentPage != 1 && !this.$route.query.resetPage) {
                        this.onPageChange(1);
                        return;
                    } 
                    this.$root.showLoader = false;
                    this.items = response.list;
                    this.totalPages = response.pagination.pageCount;
                })
                .catch((err) => {
                    this.$root.showLoader = false;
                });
        },
    },
    watch:{
        tab(val){
			if (val === this.value) {
				this.requestGetTestList();
			}
		},
        '$route.name'(val){
            this.category = this.$route.name === 'live-test' ? 'ONGOING' : 'UPCOMING'
        // this.requestGetTestList();
        this.checkSessionData();
        
        }
    },
    
    computed: {
        ...mapState("userStore", ["user"])
    },
};
</script>